import React from 'react'
import { ClientLazy } from '~/components/common'

export default function PdfClientBrowser({
  document,
}: {
  document: React.ReactElement
}) {
  return (
    <ClientLazy
      component={() => import('./lazy-pdf-viewer')}
      document={document}
    />
  )
}
